// extracted by mini-css-extract-plugin
module.exports = {"trust-list":"trust-list-5fae1d296be42d1e85ba33c3df4e33ed","list-item":"list-item-bea3f37cb790293bd48d858de52c4479"};